import { formatInTimeZone } from "date-fns-tz";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import DateRangeComp from "../../common/DateRangeComp";
import * as actions from "../redux/VipHistoryAction";
import { VipHistoryDetail } from "./VipHistoryDetail";

export const VipHistoryList = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [commid, setCommid] = useState();

  const vipHistoryState = useSelector(
    ({ vipHistory }) => vipHistory,
    shallowEqual
  );
  const timeZone = "Asia/Kuala_Lumpur";

  useEffect(() => {
    handleSearchClick();
  }, []);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const handleSearchClick = () => {
    const queryParams = {
      action: "vipcommhistory",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
    };
    dispatch(actions.fetchVipHistory(queryParams)).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <div style={{ width: "98%", margin: "5px auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <VipHistoryDetail
        setCommid={setCommid}
        commid={commid}
        setSwalProps={setSwalProps}
      />
      <div>
        <h2>{intl.formatMessage({ id: "vipHistoryDetail" })}</h2>
      </div>
      <div className="dateSearch-div">
        <div className="dateRange-div">
          <DateRangeComp
            initialRange={[
              { startDate: fromDate, endDate: toDate, key: "selection" },
            ]}
            onDateChange={handleDateChange}
          />
        </div>
        <div>
          <button
            className="btn btn-primary"
            onClick={() => handleSearchClick()}
          >
            {intl.formatMessage({ id: "search" })}
          </button>
        </div>
      </div>
      <div
        className="member-div d-flex"
        style={{
          margin: "10px auto",
        }}
      >
        <div className="member-container">
          <div className="table-responsive">
            <table className="custom-table">
              <thead>
                <tr>
                  <th className="hide-on-mobile">
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className="text-start text-nowrap">
                    {intl.formatMessage({ id: "commissionBy" })}
                  </th>
                  <th className="text-end text-nowrap">
                    {intl.formatMessage({ id: "memberCount" })}
                  </th>
                  <th className="text-nowrap text-start">
                    {intl.formatMessage({ id: "date" })}
                  </th>
                  <th className="text-nowrap text-start">
                    {intl.formatMessage({ id: "regardingOn" })}
                  </th>
                  <th className="text-nowrap text-end">
                    {intl.formatMessage({ id: "commissionNumber" })}
                  </th>
                  <th className="text-nowrap text-end">
                    {intl.formatMessage({ id: "balance" })}
                  </th>
                  <th className="text-nowrap">
                    {intl.formatMessage({ id: "fromDate" })}
                  </th>
                  <th className="text-nowrap">
                    {intl.formatMessage({ id: "toDate" })}
                  </th>
                  <th className="text-nowrap">
                    {intl.formatMessage({ id: "action" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {vipHistoryState.vipHistory?.commHistorys &&
                vipHistoryState.vipHistory.commHistorys.length > 0 ? (
                  vipHistoryState.vipHistory.commHistorys.map(
                    (report, index) => (
                      <tr key={index} className="member-row1">
                        <td className="hide-on-mobile">{index + 1}</td>
                        <td className="text-start">{report.commby}</td>
                        <td className="text-end">{report.membercount}</td>
                        <td>{report.commdate}</td>
                        <td className="text-start">{report.regardingon}</td>
                        <td className="text-end">{report.commnumber}</td>
                        <td className="text-end">{report.commbalance}</td>
                        <td>{report.fromdate}</td>
                        <td>{report.todate}</td>
                        <td>
                          <button
                            className="btn btn-primary me-1"
                            style={{
                              backgroundColor: "#00FFFF",
                              borderColor: "#00FFFF",
                              color: "black",
                            }}
                            onClick={() => {
                              setCommid(report.commid);
                            }}
                          >
                            <i className="bi bi-exclamation-circle" />
                          </button>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan="10">
                      <div className="no-record-wrapper oRecordDiv">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                {vipHistoryState && vipHistoryState.vipHistory && (
                  <tr
                    className="member-row1"
                    style={{
                      borderTop: "1px solid rgba(175, 164, 164, 0.4)",
                    }}
                  >
                    <td className="hide-on-mobile"></td>
                    <td className="text-end"></td>
                    <td className="text-end"></td>
                    <td className="text-end"></td>
                    <td className="text-end"></td>
                    <td className="text-end">
                      {intl.formatMessage({ id: "total" }) + " : "}
                    </td>
                    <td className="text-end">
                      {vipHistoryState.vipHistory.totalcomm}
                    </td>
                    <td className="text-end"></td>
                    <td className="text-end"></td>
                  </tr>
                )}
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
